// import Sass
import './style.scss';

import 'swiper/css/bundle'; // Swiper CSS

const $ = jQuery;

// Slider Posts
document.addEventListener('DOMContentLoaded', () => {
    const allApbPosts = document.querySelectorAll('.wp-block-ap-block-posts');
    Object.values(allApbPosts).map(posts => {
        const postsId = posts.id;

        // Slider
        const sliderEl = document.querySelector(`#${postsId} .apbSliderPosts`);
        if (sliderEl) {
            const { layout, columns, columnGap, sliderIsLoop, sliderIsTouchMove, sliderIsAutoplay, sliderSpeed, sliderEffect, sliderIsPageClickable, sliderIsPageDynamic } = JSON.parse(sliderEl.dataset.slider);

            'slider' === layout && new Swiper(sliderEl, {
                // Optional parameters
                direction: 'horizontal',
                slidesPerView: columns?.mobile,
                breakpoints: {
                    // when window width is >= 576px
                    576: { slidesPerView: columns?.tablet },
                    // when window width is >= 768px
                    768: { slidesPerView: columns?.desktop },
                },
                spaceBetween: columnGap,
                loop: sliderIsLoop,
                allowTouchMove: sliderIsTouchMove,
                grabCursor: sliderIsTouchMove,
                autoplay: sliderIsAutoplay ? { delay: sliderSpeed * 1000 } : false,
                speed: sliderSpeed * 1000,
                effect: sliderEffect,
                fadeEffect: { crossFade: true },
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ['-120%', 0, -500],
                    },
                    next: {
                        shadow: true,
                        translate: ['120%', 0, -500],
                    }
                },
                allowSlideNext: true,
                allowSlidePrev: true,
                autoHeight: false,
                notificationClass: null,

                // Controllers
                pagination: {
                    el: '.swiper-pagination',
                    clickable: sliderIsPageClickable,
                    dynamicBullets: sliderIsPageDynamic
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        }

        const slideHeightArray = [];
        const swiperSlide = document.querySelectorAll(`#${postsId} .apbSliderPosts .swiper-slide`);
        const swiperSlideText = document.querySelectorAll(`#${postsId} .apbSliderPosts .swiper-slide .apbPostText`);
        swiperSlideText.length && swiperSlideText.forEach(slideText => {
            slideHeightArray.push(slideText?.clientHeight);
        });
        swiperSlide.length && swiperSlide.forEach(slide => {
            slide.style.height = `${Math.max(...slideHeightArray)}px`;
        });

        // Remove data slider attributes
        sliderEl?.removeAttribute('data-slider');

        // Ticker
        const tickerEl = document.querySelector(`#${postsId} .apbTickerPosts`);
        if (tickerEl) {
            const { rowGap, tickerDirection, tickerSpeed, tickerInterval, tickerHeight, tickerVisible, tickerIsMousePause } = JSON.parse(tickerEl.dataset.ticker);

            $(tickerEl).easyTicker({
                direction: tickerDirection,
                easing: 'swing',
                speed: isNaN(tickerSpeed) ? tickerSpeed : parseInt(tickerSpeed),
                interval: tickerInterval,
                height: '0px' === tickerHeight || '0em' === tickerHeight ? 'auto' : tickerHeight,
                gap: rowGap,
                visible: tickerVisible,
                mousePause: tickerIsMousePause
            });
        }

        // Remove data ticker attributes
        tickerEl?.removeAttribute('data-ticker');

        // Posts Pagination
        const paginationEl = document.querySelector(`#${postsId} .apbPagination`);
        if (paginationEl) {
            const { subLayout, postsPerPage, paginationLength, paginationPrevLabel, paginationNextLabel } = JSON.parse(paginationEl.dataset.pagination);
            let paginationCurrentPage = 0;

            // Display Posts based on pagination
            const paginationPostDisplay = () => {
                const allSinglePost = document.querySelectorAll(`#${postsId} .apbPost`);
                allSinglePost.forEach(singlePost => {
                    singlePost.style.display = 'none';
                });

                const paginationShowStart = postsPerPage * paginationCurrentPage;
                const paginationShowEnd = paginationShowStart + postsPerPage;

                const paginationPosts = Array.from(allSinglePost)?.slice(paginationShowStart, paginationShowEnd);
                paginationPosts.map(singlePost => {
                    singlePost.style.display = 'left-image' === subLayout || 'right-image' === subLayout ? (1 === singlePost.childElementCount ? 'flex' : 'grid') : 'block';
                });
            }
            paginationPostDisplay();


            // Edit Pagination Page
            const elEditInPagination = (li, className, innerText) => {
                li.classList.add(className);
                li.innerText = innerText;
                'apbPagePrev' === className ? paginationEl.prepend(li) : paginationEl.appendChild(li);
            }

            // Prev Next Generate
            const paginationPrevNextGenerate = (pageEl, appendCondition, className, label, remCondition) => {
                appendCondition && elEditInPagination(pageEl, className, label);
                const selectPageEl = document.querySelector(`#${postsId} .apbPagination .${className}`);
                remCondition && selectPageEl && paginationEl.removeChild(pageEl);
            }

            // Pagination Page Event
            const paginationPageClick = (currentPageVal) => {
                paginationCurrentPage = currentPageVal;
                paginationPostDisplay();

                paginationPrevNextGenerate(pagePrevEl, 0 !== paginationCurrentPage, 'apbPagePrev', paginationPrevLabel, 0 == paginationCurrentPage);

                const pageNumberEl = document.querySelectorAll(`#${postsId} .apbPagination .apbPageNumber`);
                for (let i = 0; i < pageNumberEl?.length; i++) {
                    i === paginationCurrentPage ? pageNumberEl[i].classList.add('apbActivePage') : pageNumberEl[i].classList.remove('apbActivePage');
                }

                paginationPrevNextGenerate(pageNextEl, paginationLength !== paginationCurrentPage + 1, 'apbPageNext', paginationNextLabel, paginationLength == paginationCurrentPage + 1);

                // Go to top when page click
                const portWrapper = document.getElementById(postsId);
                window.scrollTo({
                    top: portWrapper.offsetTop,
                    behavior: "smooth",
                });
            }

            // Pagination Prev
            const pagePrevEl = document.createElement('li');
            pagePrevEl.addEventListener('click', () => paginationPageClick(paginationCurrentPage - 1));

            // Pagination Numbers
            [...Array(paginationLength)].map((el, index) => {
                const pageNumberEl = document.createElement('li');
                elEditInPagination(pageNumberEl, 'apbPageNumber', index + 1);

                document.querySelectorAll(`#${postsId} .apbPagination .apbPageNumber`)[0].classList.add('apbActivePage');

                pageNumberEl.addEventListener('click', () => paginationPageClick(index));
            });

            // Pagination Next
            const pageNextEl = document.createElement('li');
            pageNextEl.addEventListener('click', () => paginationPageClick(paginationCurrentPage + 1));
            paginationLength !== paginationCurrentPage + 1 && elEditInPagination(pageNextEl, 'apbPageNext', paginationNextLabel);

            // Remove data pagination attributes
            paginationEl.removeAttribute('data-pagination');
        }
    });
});